export default __webpack_public_path__ + "media/images/svgs/general_shape-f98ee284c21f98b409f2c29348907ddf.svg";